import React, { Component } from "react";
import { DatePicker } from "antd";
import moment from "moment";
import "./index.css";

class DateRange extends Component {
  state = {
    startValue: moment().startOf("month"),
    endValue: moment(),
    endOpen: false,
  };

  disabledStartDate = (startValue) => {
    const { endValue } = this.state;
    const today = moment(); // Get the current date
    if (!startValue || !endValue) {
      return false;
    }
    return (
      startValue.valueOf() > endValue.valueOf() ||
      startValue.valueOf() > today.valueOf()
    );
  };

  disabledEndDate = (endValue) => {
    const { startValue } = this.state;
    const today = moment(); // Get the current date
    if (!endValue || !startValue) {
      return false;
    }
    return (
      endValue.valueOf() <= startValue.valueOf() ||
      endValue.valueOf() > today.valueOf()
    );
  };

  onChange = (field, value) => {
    this.setState({
      [field]: value,
    });
  };

  onStartChange = (value) => {
    if (value) {
      this.onChange("startValue", value);
      this.props.getStartDate(value.format("YYYY-MM-DD"));
    } else {
      // Reset to previous start value if the value is null (cancel button was clicked)
      this.setState({ startValue: moment().startOf("month") });
    }
  };

  onEndChange = (value) => {
    if (value) {
      this.onChange("endValue", value);
      this.props.getEndDate(value.format("YYYY-MM-DD"));
    } else {
      // Reset to previous end value if the value is null (cancel button was clicked)
      this.setState({ endValue: moment() });
    }
  };

  handleStartOpenChange = (open) => {
    if (!open) {
      this.setState({ endOpen: true });
    }
  };

  handleEndOpenChange = (open) => {
    this.setState({ endOpen: open });
  };

  render() {
    const { startValue, endValue, endOpen } = this.state;
    return (
      <div className="dateRanger">
        <div>
          <p className="dateDesc">Select Start Date</p>
          <DatePicker
            disabledDate={this.disabledStartDate}
            showTime
            format="YYYY-MM-DD"
            value={startValue}
            placeholder="Start Date"
            onChange={this.onStartChange}
            onOpenChange={this.handleStartOpenChange}
            style={{ width: "240px" }}
          />
        </div>
        <div>
          <p className="dateDesc">Select End Date</p>
          <DatePicker
            disabledDate={this.disabledEndDate}
            showTime
            format="YYYY-MM-DD"
            value={endValue}
            placeholder="End Date"
            onChange={this.onEndChange}
            open={endOpen}
            onOpenChange={this.handleEndOpenChange}
            style={{ width: "240px" }}
          />
        </div>
      </div>
    );
  }
}

export default DateRange;
